import * as product from '../constants/product-types'

export const removeAllProductThatCannotBeIrregular = (p) => {
    return (
        ![product.CHRISTMAS, product.TUDO, product.POD].includes(p.id) &&
        ![product.CHRISTMAS, product.TUDO, product.POD].includes(p.productCode)
    )
}

export const removeAllProductsThatArentVendible = (p) => {
    return p.vendible !== false
}
